<template>
  <div class="select-number-control">
    <el-select
      :model-value="field.selectValue"
      class="select-number-control__operator"
      :placeholder="choosePlaceholder"
      @update:model-value="handleSelectValueUpdate">
      <el-option
        v-for="option in field.selectOptions || []"
        :key="`${field.key}-${option}`"
        :label="option"
        :value="option" />
    </el-select>
    <el-input
      :model-value="field.submitValue"
      class="select-number-control__value"
      :placeholder="field.placeholder || searchPlaceholder"
      type="number"
      clearable
      @update:model-value="handleSubmitValueUpdate">
      <template v-if="field.unit" #append>
        {{ field.unit }}
      </template>
    </el-input>
  </div>
</template>

<script setup>
/* global defineProps, defineEmits */
const props = defineProps({
  field: {
    type: Object,
    required: true
  },
  choosePlaceholder: {
    type: String,
    default: ''
  },
  searchPlaceholder: {
    type: String,
    default: ''
  }
})

const emit = defineEmits(['update-field'])

const handleSelectValueUpdate = (selectValue) => {
  emit('update-field', props.field.key, { selectValue })
}

const handleSubmitValueUpdate = (submitValue) => {
  emit('update-field', props.field.key, { submitValue: submitValue ?? '' })
}
</script>

<style lang="scss" scoped>
.select-number-control {
  display: flex;
  align-items: center;
  width: 100%;
}

.select-number-control__operator {
  width: 150px !important;
  flex-shrink: 0;
}

.select-number-control__value {
  flex: 1;
  margin-left: -1px;
}

.select-number-control :deep(.el-input__wrapper) {
  border-radius: 0 !important;
}

.select-number-control__operator :deep(.el-input__wrapper) {
  border-right: 0;
}
</style>
